import { useState, useEffect,useCallback } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import {
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from 'reactstrap';
import { Box} from '@mui/material';
import Datetime from 'react-datetime';
import './index.css';
import { userActions } from '../../../actions/user.actions';
import close from "../../../assets/images/close.png";
import Switch from 'react-bootstrap-switch';
import { useSelector, useDispatch } from "react-redux";
import * as moment from 'moment';
import action3 from "../../../assets/images/action3.png";
import 'react-bootstrap-switch/dist/css/bootstrap3/react-bootstrap-switch.min.css';
import axiosInstance from '../../../helpers/axios';
import CircularProgress from '@mui/material/CircularProgress';
import OtpConsent from '../../Consent/OtpConsent/OtpConsent';
import { ApplicationStatusEnum, states } from '../../../data';
import MuiSwitch from '@mui/material/Switch';
import {Typography} from '@mui/material';
import { useCurrentUser } from '../../../hooks/useCurrentUser';
export default function MoveProcessingStatus(ApplicantId) {
  const doReload = ApplicantId.onSuccess ?? (() => window.location.reload());
  // const { user, logOut } = useUserAuth();
  const decode = useCurrentUser();
  const user = null;
  const rejectionReasons = [
    { label: "Credit Score", value: 1 },
    { label: "Low Income", value: 2 },
    { label: "FOIR", value: 3 },
    { label: "Document Issue", value: 4 },
    { label: "Bank Analysis Fail", value: 5 },
    { label: "Policy Breach", value: 6 },
    { label: "Fraud Flag", value: 7 },
    { label: "Other", value: 8 },
  ];
  const subRejectionReasons = [
    { label: "Wrong State", value: 1 },
    { label: "Self-Employed", value: 2 },
    { label: "Age Below Minimum", value: 3 },
    { label: "Low Salary", value: 4 },
    { label: "Repeat Application", value: 5 },
    { label: "Other Policy", value: 6 },
  ];
  const bankAnalysisSubReasons = [
    { label: "Low / Insufficient Salary Credits", value: 7 },
    { label: "Bounced EMIs / Cheque Returns", value: 8 },
    { label: "High Obligations (FOIR)", value: 9 },
    { label: "Salary Not Credited / Irregular", value: 10 },
    { label: "Statement Unreadable / Parse Fail", value: 11 },
    { label: "Suspected Tampered Statement", value: 12 },
    { label: "Insufficient Transaction History", value: 13 },
    { label: "Other (Bank Analysis)", value: 14 },
  ];
const ruleStatus = ApplicantId.ApplicantId.ruleStatus
let coappRuleStatus = null;
if(ApplicantId.ApplicantId?.coapplicants?.length > 0){
 coappRuleStatus = ApplicantId.ApplicantId?.coapplicants[0]?.coapplicantRuleStatus
}
const id = ApplicantId.ApplicantId.applicationId


const name = ApplicantId.ApplicantId.name
  
  const updateDroppedStatus = `/admin/application/update-status`;
  const instituteId = ApplicantId.ApplicantId.cra === 'mcb' ? 'MyClassBoard' : ApplicantId.ApplicantId.instituteId;
  const urlApproveApiProd = `/products/instituteId/active?instituteId=${instituteId}`;
  
  // const urlApproveApiProd = `/products/instituteId/active?instituteId=${ApplicantId.ApplicantId.instituteId}`;
  const urlApproveApiFund = `/fund_source/for-institute?instituteId=${ApplicantId.ApplicantId.instituteId}`;

  const [formStatusOpen, setStatusOpen] = useState(false);
  const [dropDownOpen, setDropDownOpen] = useState(false);
  const [productDropDownOpen, setProductDropDownOpen] = useState(false);
  const [fundDropDownOpen, setFundDropDownOpen] = useState(false);
  const [descriptionText, setDescriptionText] = useState('');
  const [status, setStatus] = useState('Select Status');
  const [rejectionReason, setRejectionReason] = useState("");
  const [subRejectionReason, setSubRejectionReason] = useState("");
  const [prodArray, setProdArray] = useState([]);
  const [productName, setProductName] = useState('Product');
  const [fundSourceName, setFundSourceName] = useState('Fund Source');
  const [fundSourceArray, setFundSourceArray] = useState([]);
  const [prodLoanAmount, setLoanAmount] = useState(null);
  const [prodEmi, setEMI] = useState(null);
  const [dateEmi, setEmiDate] = useState(null);
  const [dayEmi, setEmiDay] = useState(null);
  const [disbursementDate, setDisbursementDate] = useState(null)
  const [emisDeducted, setEmisDeducted] = useState(null);
  const [form, setForm] = useState(prodArray ? prodArray : null);
  const [formLoader, setFormLoader] = useState(false);
  const [coAppNumber, setCoAppNumber] = useState(false);
  const [coAppFName, setCoAppFName] = useState('');

  const [coAppEmail, setCoAppEmail] = useState('');
  const [relationshipStatus, setRelationshipStatus] = useState('Select Relation with Applicant');
  const [relationshipStatusDropdown, setRelationshipStatusDropdown] = useState(false);
  const [confirmationDialog, setConfirmationDialog] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState('Hold On...');
  const [coAppAadhaar, setCoAppAadhaar] = useState(false);
  const [coAppAddress, setCoAppAddress] = useState(null);
  const [coAppDob, setCoAppDob] = useState(null);
  const [coAppCity, setCoAppCity] = useState("");
  const [coAppState, setCoAppState] = useState("");
  const [coAppPincode, setCoAppPincode] = useState("");
  const [coAppGender, setCoAppGender] = useState('');
  const [dobError, setDobError] = useState('');
  const [coAppPAN, setCoAppPAN] = useState(false);
  const [aadhaarBackUpload, setAadhaarBackUpload] = useState(null);
  const [aadhaarFrontUpload, setAadhaarFrontUpload] = useState(null);
  const [panUpload, setPanUpload] = useState(null);
  const [alertMessage,setAlertMessage]=useState(null)
  const [runBothEmandate,setRunBothEmandateCheck]=useState(false)
  const [runEmandate,setRunEmandateCheck]=useState(false)
  const [mandateCheckOpen,setMandateCheckOpen]=useState(false)
  const [bothMandateCheckOpen,setBothMandateCheckOpen]=useState(false)
  const [flagForMainApplicant,setFlagForMainApplicant]=useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [employment, setEmployment] = useState(null)
  const [employerName, setEmployerName] = useState(null)
  const [income, setIncome] = useState(null)
  const [discountOnPf, setDiscountOnPf] = useState(0)
  const [discountOnDc, setDiscountOnDc] = useState(0)
  const [taChange, setTAChange] = useState(true)
  const [aadhaarImage1Url, setAadhaarImage1Url] = useState('');
  const [aadhaarImage2Url, setAadhaarImage2Url] = useState('');
  const [panImageUrl, setPanImageUrl] = useState('');
  const [isApiError, setIsApiError] = useState(false);
  const [instituteList, setInstituteList] = useState(null);
  const [courseInputValue, setCourseInputValue] = useState(''); 
  const [courseId,setCourseId] = useState(null);
  const [fee,setFee] = useState(null)
  const dispatch = useDispatch()
  const droppedstate = useSelector((state) => state.Droppedstatuschange?.res)

  const [ocrFormData,setOCRFormData]=useState(null);
const[ocrReadDone,setOCRReadDone]=useState(false)


const [ocrAadhaarFront,setOCRAadhaarFront]=useState(null)
const [ocrAadhaarBack,setOCRAadhaarBack]=useState(null)
const [ocrPan,setOCRPan]=useState(null)
  const [openOtpConsent, setOpenOtpConsent] = useState(false);

const readOcr=()=>{
  setIsLoading(true)
  const readOCRUrl=`/ocr/read`
  const data=new FormData();

 if(ocrAadhaarFront)
    data.append("aadhaarFront",ocrAadhaarFront);
  if(ocrAadhaarBack)
    data.append("aadhaarBack",ocrAadhaarBack);
  if(ocrPan)
    data.append("pan",ocrPan);

  axiosInstance.post(readOCRUrl,data)
  .then((res=>{
    
    axiosInstance.get(`/ocr/data?id=${res.data.data.id}`)
    .then(async (resp) => {
  setOCRReadDone(!ocrReadDone);
  setOCRFormData(resp.data.data);
      setOCRReadDone(!ocrReadDone);
      setOCRFormData(resp.data.data);
      const gender = resp.data.data?.gender?.toLowerCase();
      setCoAppGender(gender === 'male' || gender === 'female' ?
        gender.charAt(0).toUpperCase() + gender.slice(1) : '');
  const [aadhaar1Url, aadhaar2Url, panUrl] = await Promise.all([
    handleViewFile(resp?.data?.data?.aadhaarImage1),
    handleViewFile(resp?.data?.data?.aadhaarImage2),
    handleViewFile(resp?.data?.data?.panImage),
  ]);

  setAadhaarImage1Url(aadhaar1Url);
  setAadhaarImage2Url(aadhaar2Url);
  setPanImageUrl(panUrl);
  setIsLoading(false);
})

    .catch((err)=>alert("Fail to read OCR details"))
  }))
  .catch((err)=>alert("OCR read Failed!"));
}

const extractPath = (s3Url) => {
  const keywords = ['aadhaar_front', 'aadhaar_back', 'pan'];
  for (const keyword of keywords) {
    const index = s3Url?.indexOf(keyword);
    if (index !== -1) {
      return s3Url.substring(index);
    }
  }
  return '';
};

 const handleViewFile = async (s3Url) => {
  try {

    const extractedString = extractPath(s3Url);

    const url = `/file/url-content?path=${extractedString}`;
    const res = await axiosInstance.get(url, {
      headers: {
      },
    });
    return res?.data?.data || '';
  } catch (e) {
    console.error(e);
  }
};

const previewOcrAadhaarFront=(e)=>{
  setOCRAadhaarFront(e.target.files[0])
  const output = document.getElementById('ocrAadhaarFOutput');
    output.src = URL.createObjectURL(e.target.files[0]);
    output.onload = function() {
      URL.revokeObjectURL(output.src) // free memory
    }
  }
const previewOcrAadhaarBack=(e)=>{
  setOCRAadhaarBack(e.target.files[0])
  const output = document.getElementById('ocrAadhaarBOutput');
    output.src = URL.createObjectURL(e.target.files[0]);
    output.onload = function() {
      URL.revokeObjectURL(output.src) // free memory
    }
  }
const previewOcrPan=(e)=>{
  setOCRPan(e.target.files[0])
  const output = document.getElementById('ocrPanOutput');
    output.src = URL.createObjectURL(e.target.files[0]);
    output.onload = function() {
      URL.revokeObjectURL(output.src) // free memory
    }
  }
const handleMainApplicantSelectApplicant=()=>{
  document.getElementById("applicantCheck").checked=true
  document.getElementById("coapplicantCheck").checked=false
  setFlagForMainApplicant(document.getElementById("coapplicantCheck").checked)
  

    
}
const handleMainApplicantSelectCoApplicant=()=>{
   document.getElementById("applicantCheck").checked=false
  document.getElementById("coapplicantCheck").checked=true
  setFlagForMainApplicant(document.getElementById("coapplicantCheck").checked)

}

const handlemandateCheckbox=(value)=>{
     
  setRunEmandateCheck(value)
  if(value)
  setMandateCheckOpen(!mandateCheckOpen)
}
const handleRunEmandateBox=(value)=>{
    document.getElementById("runEmandate").checked=value
    document.getElementById("runBothEmandate").checked=false
 handlemandateCheckbox(value)
    
}
const handleBothMandateCheckbox=(value)=>{
  setRunBothEmandateCheck(value)
  if(value)
  setBothMandateCheckOpen(!bothMandateCheckOpen)
}
const handleRunBothEmandateBox=(value)=>{
    document.getElementById("runEmandate").checked=false
    document.getElementById("runBothEmandate").checked=value

   handleBothMandateCheckbox(value)
}



//get Emi
  const [backendPan,setBackendPan]=useState(null)
  const [backendAadhaarFront,setBackendAadhaarFront]=useState(null)
  const [backendAadhaarBack,setBackendAadhaarBack]=useState(null)
  const [emiData,setEmiData]=useState(null)
  const updateStatusUrl = ApplicantId.ApplicantId.instituteId ==="9d5eca4b-54f7-42a7-8794-1413e00b462e"?`/application/assign-fundsource-qec`:`/admin/application/assign-fund-source`;
  const AddCoApplicantUrl = `/admin/application/add-coapplicant`;

  const popUpStatusForm = () => {
    setStatusOpen(true);
  };


  //get string validation
  const getStringContain=(str)=>{
    return (/\d/.test(str))
  }
  //get email validation
  const validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };


  const addBijayCoApplicant = async () => {
    if(document.getElementById('coAppName').value.length>0&&document.getElementById('coAppDob').value.length>0&&document.getElementById('coAppNumber').value.length===10&&document.getElementById('coAppZip').value.length>0&&document.getElementById('coAppEmail').value
    && (income || employment==="UNEMPLOYED") )
      {
      setFormLoader(true);
    const statusData = {
      mandatePrimary: runEmandate?true:false,
      checkCibil:true,
      aadhaarFront:backendAadhaarFront?backendAadhaarFront:ocrFormData?.aadhaarImage1,
      dateOfBirth:coAppDob?moment(coAppDob).format('YYYY-MM-DD'):ocrFormData?.dobPerAadhaar?moment(ocrFormData?.dobPerAadhaar).format('YYYY-MM-DD'):moment(ocrFormData?.dobPerPan).format('YYYY-MM-DD'),
      currentCity:coAppCity?coAppCity:ocrFormData?.city,
      currentState:coAppState?coAppState:ocrFormData?.state,
      currentPincode:coAppPincode?coAppPincode:ocrFormData?.pincode,
      aadhaarBack:backendAadhaarBack?backendAadhaarBack:ocrFormData.aadhaarImage2?ocrFormData.aadhaarImage2:null,
      panImage:backendPan?backendPan:ocrFormData?.panImage,
      address:coAppAddress?coAppAddress?.trim():ocrFormData?.address,
      panId: coAppPAN?coAppPAN?.trim():ocrFormData?.panId,
      aadhaarId: coAppAadhaar?coAppAadhaar?.trim():ocrFormData?.aadhaarId,
      applicationId: ApplicantId.ApplicantId.applicationId,
      name: coAppFName?coAppFName?.trim():ocrFormData?.fullNamePerPan,
      mobile: coAppNumber,
      employmentType:
      employment === "EMPLOYED"
        ? "salaried"
        : employment === "SELF_EMPLOYED"
        ? "self-employed"
        : "unemployed",
      employerName: employment==="EMPLOYED"?employerName:"",
      salary: employment==="EMPLOYED"?income:"",
      incomePerMonth: employment==="SELF_EMPLOYED"?income:"",
      typeOfBusiness: employment==="SELF_EMPLOYED"?employerName:"",
      email: coAppEmail?.trim(),
      ...(relationshipStatus !== 'Select Relation with Applicant' && { relation: relationshipStatus }),
      isCoapplicant:flagForMainApplicant,
      mandateForBoth:runBothEmandate,
      rulesStatus: ruleStatus
    };
    try {
      const res = await axiosInstance.post(`${AddCoApplicantUrl}`, statusData, {
        headers: {
          'Content-type': 'application/json',
        },
      })
      if(res.data.message === 'Successful'){
        return res?.data?.data
      }
    } catch (e) {
    }
  }
  else{
    setAlertMessage("Incomplete Information Please Check")
  }
  }

  const submitApplicationToInReview = async () => {

    const coAppUserId = await addBijayCoApplicant()
            
    if (!coAppUserId) {
      throw new Error("Failed to fetch co-applicant ID");
    }

    try {
      let authToken = null;

      // 1st Api call
      const authResponse = await axiosInstance.post(`/login/auth`, {
        memberId: coAppUserId,
      });

      authToken = authResponse?.data?.data;

      if (!authToken) {
        throw new Error("Authentication token not received");
      }

      const data = {
        userId: coAppUserId,
        latitude: 0,
        longitude: 0,
        doneBy: 'end-user',
      };

      // 2nd API call
      await axiosInstance.post('/end-user/submit/coapplicant-admin', data, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          'Content-Type': 'application/json',
        },
      });
        alert('Application Moved to In Process')
        setTimeout(() => {
          doReload()
        }, 1000)
      }
      catch (error) {
        alert(`Error while processing your request. Please try again. ${error.message}`);
        // setTimeout(() => {
        //   doReload()
        // }, 1000)
      }
  };

//get s3 link of uploaded files
const handleAadhaarFrontFileUpload = (item) => {
    
    const data = new FormData();
    data.append('file', item);
    data.append('type', "aadhaar_front");

    axiosInstance
      .post(`/file/upload`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(
        (response) => {
         setBackendAadhaarFront(response.data.data.s3Url)
         document.getElementById("aadhaarFrontUploadButton").className="successFront"
         document.getElementById("aadhaarFrontUploadButton").innerText="Success"
        },
        (error) => {
          alert('Check Mandatory Fields and File format');
        },
      );
  };
const handleAadhaarBackFileUpload = (item) => {

    const data = new FormData();
    data.append('file', item);
    data.append('type', "aadhaar_back");

    axiosInstance
      .post(`/file/upload`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(
        (response) => {
         setBackendAadhaarBack(response.data.data.s3Url)
         document.getElementById("aadhaarBackUploadButton").className="successFront"
         document.getElementById("aadhaarBackUploadButton").innerText="Success"
        },
        (error) => {
          alert('Check Mandatory Fields and File format');
        },
      );
  };
const handlePanFileUpload = (item) => {

    const data = new FormData();
    data.append('file', item);
    data.append('type', "pan");

    axiosInstance
      .post(`/file/upload`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(
        (response) => {
         setBackendPan(response.data.data.s3Url)
         document.getElementById("PanUploadButton").className="successFront"
         document.getElementById("PanUploadButton").innerText="Success"
        },
        (error) => {
          alert('Check Mandatory Fields and File format');
        },
      );
  };

 

  const handleConsent = () => {
    setOpenOtpConsent(!openOtpConsent);
  }
 
 const getInstituteInfo = useCallback((text) => {
    setInstituteList([]);

    if (text.length >= 4) {
      const urlGetInstitute = `/institute/info/active?instituteId=${ApplicantId?.ApplicantId?.instituteId}&name=${text}`;

      axiosInstance.get(urlGetInstitute, {
        headers: {
        },
      })
      .then((res) => {
        setInstituteList(res.data.data);
      })
      .catch((err) => {
        console.error("Error fetching institute info:", err);
        setInstituteList([]); 
      });
    } else {
      setInstituteList([]);
    }
  }, [ApplicantId?.ApplicantId?.instituteId, user]);

   const handleInputChange = (e) => {
    const text = e.target.value;
    setCourseInputValue(text); 
    getInstituteInfo(text);
  };
   const handleCourseSelect = (selectedItem) => {
    setCourseInputValue(selectedItem.courseName);
    setCourseId(selectedItem.id) ;
    setFee(selectedItem.fees)
    setInstituteList([]); 
  };

  const calculatedDiscountFee = (Number(fee) || 0) - (Number(prodLoanAmount) || 0);
  const handleStatusChange = () => {
    if (status === 'Status') {
      alert('NO STATUS CHANGE !');
    } else if (status === 'Assign Fund Source' && fundSourceName !== "Fund Source") {
        if(dateEmi && (dayEmi > 0)){
          setFormLoader(!formLoader);
          setStatusOpen(!formStatusOpen);
          setConfirmationDialog(!confirmationDialog);
          const statusData = {
            applicationId: ApplicantId.ApplicantId.applicationId,
            fundCode: fundSourceName,
            productId: form.productId,
            loanAmount: prodLoanAmount,
            loanTenure: form.tenure===0 ? ApplicantId?.ApplicantId?.tenure:form.tenure,
            emi: prodEmi?prodEmi:emiData,
            emiFirstDate: dateEmi,
            dayOfEmi: dayEmi,
            rulesStatus: ruleStatus,
            tentativeDisbursementDate: disbursementDate,
            emisDeducted: emisDeducted,
            pfActual: parseFloat(calculatePfValue("actualPf").toFixed(2)),
            discountOnPf: discountOnPf,
            pfToBePaid: parseFloat((decode?.clientId === "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" ? calculatePfValue('pfAfterGst') : calculatePfValue('pfAfterDisCount')).toFixed(2)),
            dcActual: parseFloat(calculatePfValue("actualPf").toFixed(2)),
            discountOnDc: discountOnDc,
            dcToBePaid: parseFloat(calculatePfValue('dcAfterGst').toFixed(2)),
            tradeAdvance: taChange? 1: 0,
            courseId:courseId,
            discount:calculatedDiscountFee,
            ...(fundSourceName === "AVN" && {
                courseId: courseId,
                dscount: calculatedDiscountFee
            })
          };

          axiosInstance
            .post(`${updateStatusUrl}`, statusData, {
              headers: {
                'Content-type': 'application/json',
              },
            })
            .then(
              (res) => {
                if (res.data.message === 'Successful') {
                  setConfirmationMessage('Move to In Process Successfully');
                  setTimeout(() => setConfirmationDialog(!confirmationDialog), 2000);
                  setTimeout(() => setConfirmationDialog(false), 2000);
                  setTimeout(() => doReload(), 500);
                }
              },
              (error) => {
                alert(' Unsuccessful!!! Check Fields/Format');
                setTimeout(() => setConfirmationDialog(!confirmationDialog), 2000);
                  setTimeout(() => setConfirmationDialog(false), 2000);
                  setTimeout(() => doReload(), 1000);
              },
            );
        }else{
          setAlertMessage("Incomplete Information Please Check")
        }
    } else if (status === 'Dropped') {
      const droppedData = {
        userId: ApplicantId.ApplicantId.userId,
        applicationId: ApplicantId.ApplicantId.applicationId,
        status: ApplicationStatusEnum.Dropped,
        notes: descriptionText,
          };
          if(droppedstate){
            if (droppedstate.message === 'Successful') {
              setFormLoader(!formLoader);
              setStatusOpen(!formStatusOpen);
              setConfirmationDialog(!confirmationDialog);
              setConfirmationMessage('Dropped Successfully');
              setTimeout(() => setConfirmationDialog(!confirmationDialog), 2000);
              setTimeout(() => setConfirmationDialog(false), 2000);
              setTimeout(() => doReload(), 500);
            }else{
              setConfirmationMessage("error");
              setTimeout(() => setConfirmationDialog(!confirmationDialog), 2500);
                setTimeout(() => setConfirmationDialog(false), 2750);
            }
          }else{
            dispatch(userActions.fetchDroppedstatuschange(updateDroppedStatus,droppedData, user),[])
          }
      
    }
     else if (status === 'Add Co-Applicant') {

      
        
        // setFormLoader(!formLoader);
        // setStatusOpen(!formStatusOpen);
        // setConfirmationDialog(!confirmationDialog);
        if(document.getElementById('coAppName').value.length>0&&document.getElementById('coAppDob').value.length>0&&document.getElementById('coAppNumber').value.length===10&&document.getElementById('coAppZip').value.length>0&&document.getElementById('coAppEmail').value)
        {
          if(decode?.clientId==="98ffb18a-9fee-43a5-91a3-4b2b9d9ae361"){
            // 
            handleConsent()
            return
          }
           setFormLoader(!formLoader);
         setIsApiError(false); 
          const statusData = {
            mandatePrimary: runEmandate?true:false,
            checkCibil: true,
            aadhaarFront:backendAadhaarFront?backendAadhaarFront:ocrFormData?.aadhaarImage1,
            dateOfBirth:coAppDob?moment(coAppDob).format('YYYY-MM-DD'):ocrFormData?.dobPerAadhaar?moment(ocrFormData?.dobPerAadhaar).format('YYYY-MM-DD'):moment(ocrFormData?.dobPerPan).format('YYYY-MM-DD'),
            currentCity:coAppCity?coAppCity:ocrFormData?.city,
            currentState:coAppState?coAppState:ocrFormData?.state,
            currentPincode:coAppPincode?coAppPincode:ocrFormData?.pincode,
            aadhaarBack:backendAadhaarBack?backendAadhaarBack:ocrFormData?.aadhaarImage2?ocrFormData?.aadhaarImage2:null,
            panImage:backendPan?backendPan:ocrFormData?.panImage,
            address:coAppAddress?coAppAddress?.trim():ocrFormData?.address,
            panId: coAppPAN?coAppPAN?.trim():ocrFormData?.panId,
            aadhaarId: coAppAadhaar?coAppAadhaar?.trim():ocrFormData?.aadhaarId,
            applicationId: ApplicantId.ApplicantId.applicationId,
            name: coAppFName?coAppFName?.trim():ocrFormData?.fullNamePerPan,
            mobile: coAppNumber,
            gender: coAppGender,
            employmentType:
            employment === "EMPLOYED"
              ? "salaried"
              : employment === "SELF_EMPLOYED"
              ? "self-employed"
              : employment,
            employerName: employment==="EMPLOYED"?employerName:"",
            salary: employment==="EMPLOYED"?income:"",
            incomePerMonth: employment==="SELF_EMPLOYED"?income:"",
            typeOfBusiness: employment==="SELF_EMPLOYED"?employerName:"",
            email: coAppEmail?.trim(),
            ...(relationshipStatus !== 'Select Relation with Applicant' && { relation: relationshipStatus }),
            isCoapplicant:flagForMainApplicant,
            mandateForBoth:runBothEmandate,
            rulesStatus: ruleStatus
          };
  
          axiosInstance.post(`${AddCoApplicantUrl}`, statusData, {
              headers: {
                'Content-type': 'application/json',
              },
            })
            .then(
              (res) => {
                if (res.data.message === 'Successful') {
                  setConfirmationMessage('Co Applicant Added Successfully');
                  setConfirmationDialog(true);
                  setFormLoader(false);
                  setStatusOpen(false); 
                  setTimeout(() => {
                        setConfirmationDialog(false);
                        doReload();
                    }, 2000);
                }
              },
              (error) => {
                 setFormLoader(false);
                setIsApiError(true); 

                const errorMessages = error?.response?.data?.message;
                const formattedErrors = Array.isArray(errorMessages) 
                    ? errorMessages.map((item, key) => <p key={key}>{key + 1}. {item}</p>)
                    : <p>{String(errorMessages) || "An unknown error occurred."}</p>

                setConfirmationMessage(
                  <>
                    <p style={{fontWeight: 'bold'}}>Submission failed. Please check the errors:</p>
                    {formattedErrors}
                  </>
                );

                setConfirmationDialog(true);
              },
            
          );
        }
        else
        {
          setAlertMessage("Incomplete Information Please Check")
          setTimeout(() => {
            setAlertMessage(null)
          }, 3000);
        }
          
    } else if(status==="Rejected"){
      if (!rejectionReason) {
        setConfirmationDialog(true);
        setConfirmationMessage("Please select rejection reason");
        return;
      }
      if ((Number(rejectionReason) === 6 || Number(rejectionReason) === 5) && !subRejectionReason) {
        setConfirmationDialog(true);
        setConfirmationMessage("Please select sub rejection reason");
        return;
      }
      if (Number(rejectionReason) === 8 && descriptionText.trim().length < 10) {
        setConfirmationDialog(true);
        setConfirmationMessage("Please enter a Remarks note of at least 10 characters");
        return;
      }
      const rejectedData = {
        userId: ApplicantId.ApplicantId.userId,
        applicationId: ApplicantId.ApplicantId.applicationId,
        status: ApplicationStatusEnum.Rejected,
        notes: descriptionText,
        rejectionReason: Number(rejectionReason),
        rejectionSubReason: (Number(rejectionReason) === 6 || Number(rejectionReason) === 5) ? Number(subRejectionReason) : null,
      };
      if(droppedstate){
        if (droppedstate.message === 'Successful') {
          setFormLoader(!formLoader);
          setStatusOpen(!formStatusOpen);
          setConfirmationDialog(!confirmationDialog);
          setConfirmationMessage('Rejected Successfully');
          setTimeout(() => setConfirmationDialog(!confirmationDialog), 2000);
          setTimeout(() => setConfirmationDialog(false), 2000);
          setTimeout(() => doReload(), 500);
        }else{
          setConfirmationMessage("error");
              setTimeout(() => setConfirmationDialog(!confirmationDialog), 2500);
              setTimeout(() => setConfirmationDialog(false), 2750);
        }
      }else{
        dispatch(userActions.fetchDroppedstatuschange(updateDroppedStatus,rejectedData, user),[])
      }
    }
    else if(status==="On Hold"){
      const onholdData = {
        userId: ApplicantId.ApplicantId.userId,
        applicationId: ApplicantId.ApplicantId.applicationId,
        status: ApplicationStatusEnum.OnHold,
        notes: descriptionText,
      };
      if(droppedstate){
        if (droppedstate.message === 'Successful') {
          setFormLoader(!formLoader);
          setStatusOpen(!formStatusOpen);
          setConfirmationDialog(!confirmationDialog);
          setConfirmationMessage('Application is in On Hold Now ...');
          setTimeout(() => setConfirmationDialog(!confirmationDialog), 2000);
          setTimeout(() => setConfirmationDialog(false), 2000);
          setTimeout(() => doReload(), 500);
        }else{
          setConfirmationMessage("error");
            setTimeout(() => setConfirmationDialog(!confirmationDialog), 2500);
              setTimeout(() => setConfirmationDialog(false), 2750);
        }
      }else{
        dispatch(userActions.fetchDroppedstatuschange(updateDroppedStatus,onholdData, user),[])
      }
    }
    else if (status === 'Send Self Service FeeMonk Link') {
      const applicant = ApplicantId.ApplicantId;
      const payload = {
        mobile: applicant.mobile,
        channelId: 6,
        courseName: applicant.courseName,
        instituteName: applicant.instituteName,
        courseFees: applicant.courseFees,
        loanTenure: applicant.tenure,
        firstName: applicant.name?.split(' ')[0] ?? '',
        lastName: applicant.name?.split(' ').slice(1).join(' ') ?? '',
        pincode: '',
        productId: applicant.productId ?? '',
        userId: applicant.userId,
        applicationId: applicant.applicationId,
      };
      setFormLoader(true);
      axiosInstance.post('/admin/application/send-loan-application', payload)
        .then(() => {
          setFormLoader(false);
          setStatusOpen(false);
          setConfirmationDialog(true);
          setConfirmationMessage('Self Service FeeMonk Link Sent Successfully');
          setTimeout(() => { setConfirmationDialog(false); doReload(); }, 2000);
        })
        .catch(() => {
          setFormLoader(false);
          setConfirmationDialog(true);
          setConfirmationMessage('Error sending FeeMonk link');
          setTimeout(() => setConfirmationDialog(false), 2500);
        });
    }

  };
  useEffect(()=>{
    handleStatusChange();
  },[droppedstate])

  const handleApproveForm = (x, y, applId) => {
    
    setProductName(x.target.innerText);
      const urlgetEmi=`/admin/application/emi?applicationId=${applId}&productId=${y.productId}`
      axiosInstance.get(urlgetEmi,{
      headers:{
      }
    }).then((res)=>{
 
      setEmiData(res.data.data)
    document.getElementById("defaultEMI").defaultValue = res.data.data
  })

   setForm(y)
  };


  //set colender fund source
  const [colenderFundSource,setColenderFundSource]=useState(null)
  const getUserInfo=`/admin/user-info`
const getColenderFundSource=()=>{

  axiosInstance.get(getUserInfo,{
        headers:{
        }
      }).then((res)=>{
      if(res.data.data.colenderId)
      {
        axiosInstance.get(`/fund_source/fund_code?fundCode=${res.data.data.colenderId}`,{
        headers:{
        }
      })
        .then((result)=>
        setColenderFundSource(result.data.data.fundCode))
      }
    })
  }
  const handleApproveApi = (x, y, z) => {
 
    
    setStatus(x.target.innerText);
    setRejectionReason("");
    setSubRejectionReason("");
    axiosInstance
      .get(urlApproveApiProd, {
        headers: {
        },
      })
      .then((res) =>{   
         //setting loan amount
        setLoanAmount(z)
        document.getElementById("loanAmount").defaultValue=z;
        const products = res?.data?.data.filter(item => item.tenure === ApplicantId?.ApplicantId?.tenure);
        if(ApplicantId?.ApplicantId?.instituteId === "c22afc91-f512-4dbb-bb06-f4b2242b11a3" || ApplicantId?.ApplicantId?.instituteId === "9da7515a-53ba-450a-b3da-4e600edb62bc" || decode?.clientId==="98ffb18a-9fee-43a5-91a3-4b2b9d9ae361"){
          setProdArray(res?.data?.data)
        }else{
        setProdArray(products)
        }
      }
      );


    if(decode.role==='co_lender')
    {
      getColenderFundSource()
    }
    else{
      axiosInstance
      .get(urlApproveApiFund, {
        headers: {
        },
      })
      .then((res) => setFundSourceArray(res.data.data));
    }
        
  };
  const handleToggle = () => {
    setDropDownOpen(!dropDownOpen);
  };
  const handleRelationshipToggle = () => {
    setRelationshipStatusDropdown(!relationshipStatusDropdown);
  };
  const handleProductToggle = () => {
    setProductDropDownOpen(!productDropDownOpen);
  };
  const handleFundToggle = () => {
    setFundDropDownOpen(!fundDropDownOpen);
  };
  const handleDescriptionText = (text) => {
    setDescriptionText(text);
  };




  //upload Docs 
  let aadhaarFrontPreview='';
  aadhaarFrontPreview = aadhaarFrontUpload ? URL.createObjectURL(new Blob([aadhaarFrontUpload], { type: 'application/jpg' })) : '#';
  let aadhaarBackPreview='';
  aadhaarBackPreview = aadhaarBackUpload ? URL.createObjectURL(new Blob([aadhaarBackUpload], { type: 'application/jpg' })) : '#';
  let pancardPreview='';
  pancardPreview = panUpload ? URL.createObjectURL(new Blob([panUpload], { type: 'application/jpg' })) : '#';


  //handleForm Reset
const handleFormReset=()=>{
  setRelationshipStatus("Select Relation with Applicant");
  setOCRFormData(null);
  setOCRReadDone(false);
  setAadhaarFrontUpload(null);
  setAadhaarBackUpload(null);
  setPanUpload(null);
  aadhaarBackPreview="";
  aadhaarFrontPreview="";
  pancardPreview="";
  
  setCoAppAadhaar(null);
  setCoAppEmail(null);
  setCoAppNumber(null);
  setCoAppPAN(null);
  setCoAppFName("");
  

}

const handleOnLoad=(e)=>{
setStatus(e.target.innerText)
  if (e.target.innerText !== "Rejected") {
    setRejectionReason("");
    setSubRejectionReason("");
  }
handleFormReset()
}



const handleEmploymentChange = (e) => {
  setEmployment(e.target.value)
}

  const handleDOBChange = (dob) => {
    setCoAppDob(dob);
    if (dob) {
      const birthYear = new Date(dob).getFullYear();
      const currentYear = new Date().getFullYear();
      const age = currentYear - birthYear;
      if (age < 21 || age > 59) {
        setDobError('Age must be between 21 and 59 years');
      } else {
        setDobError('');
      }
    }
  };
 const handleDeductEmis = (e) => {
   const value = e.target.value;
   if(/^\d*$/.test(value) || value === ''){
      const numericValue = Number(value)
      if(numericValue >= (form.tenure===0 ? ApplicantId?.ApplicantId?.tenure: form?.tenure)){
        alert("Emis Deducted cannot be greater than Tenure");
        document.getElementById("emisDeducted").value = "";
        setEmisDeducted(null);
        return;
      }
      setEmisDeducted(numericValue); 
   }
 }
  
  const calculatePfValue = (type) => {
    let finalValue = 0
    if(type==="pfAfterDisCount"){
      finalValue = form.processingfeeType ===  2 ? ((prodLoanAmount * form.processingfeeValue) - discountOnPf) :  (form.processingfeeValue - discountOnPf)
    }if(type==="dcAfterDisCount"){
      finalValue = form.processingfeeType ===  2 ? ((prodLoanAmount * form.processingfeeValue) - discountOnDc) :  (form.processingfeeValue - discountOnDc)
    }else if(type==="pfAfterGst"){
      finalValue=form.processingfeeType ===  2 ? ((prodLoanAmount * form.processingfeeValue) - discountOnPf) + (((prodLoanAmount * form.processingfeeValue) - discountOnPf) * 0.18): ((form.processingfeeValue - discountOnPf) + ((form.processingfeeValue - discountOnPf) * 0.18))
    }else if(type==="dcAfterGst"){
      finalValue=form.processingfeeType ===  2 ? ((prodLoanAmount * form.processingfeeValue) - discountOnDc) + (((prodLoanAmount * form.processingfeeValue) - discountOnDc) * 0.18): ((form.processingfeeValue - discountOnDc) + ((form.processingfeeValue - discountOnDc) * 0.18))
    }else{
      finalValue=form.processingfeeType ===  2 ? (prodLoanAmount * form.processingfeeValue) :  (form.processingfeeValue)
    }
    return finalValue
  }
  const handleTASwitchChange = (e) => {
    setTAChange(e.target.checked)
  }   

  const isUnrestrictedRole =
  decode?.role === 'admin' || decode?.role === 'crm' || decode?.role === 'crsa' || decode?.role === 'institute_cra';

const effectiveStatus =
  coappRuleStatus !== null && coappRuleStatus !== undefined
    ? coappRuleStatus
    : ruleStatus;

const isDisabled = !isUnrestrictedRole && (
  effectiveStatus === 2 ||
  effectiveStatus === 3
);




  return (
    <div >
       <img style={{cursor:'pointer',width:'1.1vw'}} onClick={() => popUpStatusForm()} src={action3} alt=""/>
      
     <Modal isOpen={confirmationDialog} toggle={() => setConfirmationDialog(false)}>
    <ModalHeader toggle={() => setConfirmationDialog(false)}>
        {isApiError ? 'Submission Error' : 'Waiting For Confirmation'}
    </ModalHeader>
    <ModalBody>
        {confirmationMessage}
    </ModalBody>
    {isApiError && (
        <ModalFooter>
            <Button color="secondary" onClick={() => setConfirmationDialog(false)}>
                Close
            </Button>
        </ModalFooter>
    )}
</Modal>
      <Modal style={{
        
       height:"100%",
       overflowY:"auto",
       overflowX:"auto",
        width:"100%",
        borderRadius:"10px",
      }} isOpen={formStatusOpen} size="xl">
       <div style={{backgroundColor:"#E9E9E9",borderTopLeftRadius:'10px',borderTopRightRadius:'10px'}}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:'space-between',alignItems:'center', height:'60px',padding:"10px"}}>
                <p style={{fontFamily:"Inter-Medium",fontSize:'14px', marginTop:'12px'}}>Update Status Here ( Review to <span style={{fontFamily:"Inter-Medium",color:'#D32028'}}>{status}</span> )</p>
                <img src={close} alt="Close" style={{cursor:'pointer'}} onClick={() => setStatusOpen(!formStatusOpen)}/>
            </div>
            </div>
           
            <div style={{marginTop:'10px'}}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:"space-between",backgroundColor:'#FCF0F1',borderRadius:"10px"}}>
              <p style={{marginLeft:"15px",fontFamily:"Inter-Medium",fontSize:"14px",color:"#D32028"}}>Application ID <br/><span style={{fontFamily:"Inter-Medium",fontSize:"14px",color:"black"}}>{id}</span></p>
               <p style={{marginRight:"15px",fontFamily:"Inter-Medium",fontSize:"14px",color:"#D32028"}}> Applicant Name<br/><span style={{fontFamily:"Inter-Medium",fontSize:"14px",color:"black"}}>{name}</span></p>
            </div>
         
          
        </div>
        <ModalBody>
        
          <div style={{ display: "flex", gap: "20px", alignItems: "flex-end" }}>
            <div>
            <p style={{lineHeight:'10px',fontFamily:"Inter-Medium",fontSize:'14px'}}>Select Status*</p>
              <Dropdown isOpen={dropDownOpen} toggle={() => handleToggle()}>
                <DropdownToggle style={{lineHeight:'10px',textAlign:"left",height:'40px',width:'330px',backgroundColor:'white',color:'gray',fontFamily:"Inter-Medium",fontSize:'14px'}} >
                  {status}<span style={{ position: 'absolute',left:"300px", top: '50%', transform: 'translateY(-50%)' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                      <path fill="currentColor" d="M1.5 4.5l4.5 4.5 4.5-4.5z" />
                    </svg>
                  </span>
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem style={{fontFamily:"Inter-Medium",fontSize:'14px'}} onClick={(e) => handleApproveApi(e, ApplicantId.ApplicantId.instituteId,ApplicantId.ApplicantId.courseFees)}   disabled={isDisabled}>
                  Assign Fund Source
                  </DropdownItem>
                  <DropdownItem  style={{fontFamily:"Inter-Medium",fontSize:'14px'}}onClick={(e) => handleOnLoad(e)}>
                  Rejected
                  </DropdownItem>
                  {decode?.clientId!=="98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" &&
                  <DropdownItem style={{fontFamily:"Inter-Medium",fontSize:'14px'}} onClick={(e) => handleOnLoad(e)}   disabled={isDisabled}>
                    Add Co-Applicant
                  </DropdownItem>
                  }
                  <DropdownItem style={{fontFamily:"Inter-Medium",fontSize:'14px'}} onClick={(e) => handleOnLoad(e)}>
                  Dropped
                  </DropdownItem>
                  <DropdownItem style={{fontFamily:"Inter-Medium",fontSize:'14px'}} onClick={(e) => handleOnLoad(e)}>
                  On Hold
                  </DropdownItem>
                  {ApplicantId.ApplicantId.channel === 6 && (
                  <DropdownItem style={{fontFamily:"Inter-Medium",fontSize:'14px'}} onClick={(e) => handleOnLoad(e)}>
                  Send Self Service FeeMonk Link
                  </DropdownItem>
                  )}
                </DropdownMenu>
              </Dropdown>
              </div>
          {status === "Rejected" && (
            <div>
              <p style={{ lineHeight: '10px', fontFamily: "Inter-Medium", fontSize: '14px' }}>
                Rejection Reason*
              </p>

              <select
                value={rejectionReason}
                onChange={(e) =>{ 
                  setRejectionReason(e.target.value)
                  setSubRejectionReason("");
}}
                style={{
                  lineHeight: '10px',
                  textAlign: "left",
                  height: '40px',
                  width: '330px',
                  backgroundColor: 'white',
                  color: 'gray',
                  fontFamily: "Inter-Medium",
                  fontSize: '14px',
                  borderRadius: "5px",
                  border: "1px solid #ced4da",
                  paddingLeft: "10px",
                }}
              >
                <option value="">Select Rejection Reason</option>
                {rejectionReasons.map((reason) => (
                  <option key={reason.value} value={reason.value}>
                    {reason.label}
                  </option>
                ))}
              </select>
            </div>
          )}

            {status === "Rejected" && (Number(rejectionReason) === 6 || Number(rejectionReason) === 5) && (
              <div style={{ width: "330px" }}>
                <p
                  style={{
                    lineHeight: "10px",
                    fontFamily: "Inter-Medium",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Sub Rejection Reason*
                </p>

                <select
                  value={subRejectionReason}
                  onChange={(e) => setSubRejectionReason(e.target.value)}
                  style={{
                    height: "40px",
                    width: "330px",
                    backgroundColor: "white",
                    color: "gray",
                    fontFamily: "Inter-Medium",
                    fontSize: "14px",
                    borderRadius: "5px",
                    border: "1px solid #ced4da",
                    paddingLeft: "10px",
                  }}
                >
                  <option value="">Select Sub Rejection Reason</option>
                  {(Number(rejectionReason) === 6 ? subRejectionReasons : bankAnalysisSubReasons).map((reason) => (
                    <option key={reason.value} value={reason.value}>
                      {reason.label}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>
              {/* {
                status==='Request Co-Applicant'?
                <div style={{marginTop:'1em'}}>
                  <p style={{textAlign:'center',fontWeight:'600',backgroundColor:'aliceBlue',padding:'0.5em'}}>ON<span style={{color:'red'}}> SAVE AND SUBMIT </span><br/>A SMS WILL BE  SENT<br/>TO THE APPLICANT<p style={{textDecoration:'underline'}}> TO FILL
                    CO-APPLICANT DETAILS ! </p></p> 
                </div>:null

              } */}
              {status === 'Assign Fund Source' ? (
                <div style={{ display: 'flex' }}>
                  <div style={{ display: 'block', width:'50%' }}>
                    <div style={{ display: 'flex' }}>
                      <Dropdown isOpen={fundDropDownOpen} toggle={() => handleFundToggle()}>
                        <DropdownToggle style={{border:"none", marginTop: '1em',fontFamily:"Inter-Medium",fontSize:'14px',backgroundColor:'#D32028' }} caret >
                          {decode.role==='co_lender'?colenderFundSource:fundSourceName}
                        </DropdownToggle>
                        {decode.role==='co_lender'?null:<DropdownMenu>
                          {fundSourceArray.map((item, idx) => {
                            return (
                              // eslint-disable-next-line react/no-array-index-key
                              <DropdownItem
                                key={idx}
                                onClick={(e) => setFundSourceName(e.target.innerText)}
                              >
                                {item}
                              </DropdownItem>
                            );
                          })}
                        </DropdownMenu>}
                      </Dropdown>
                      <Dropdown
                        style={{ marginLeft: '4em' }}
                        isOpen={productDropDownOpen}
                        toggle={() => handleProductToggle()}
                      >
                        <DropdownToggle style={{border:"none", marginTop: '1em',fontFamily:"Inter-Medium",fontSize:'14px',backgroundColor:"#D32028" }} caret >
                          {productName}
                        </DropdownToggle>

                        <DropdownMenu>
                          {prodArray.map((item, idx) => {
                            return (
                              // eslint-disable-next-line react/no-array-index-key
                              <>
                              {item.name==="SSSV090101"||item.name==="TSSV090200"?null:<DropdownItem
                                key={idx}
                                onClick={(e) => handleApproveForm(e, prodArray[idx],ApplicantId.ApplicantId.applicationId)}
                              >
                                {item.name}
                              </DropdownItem>}
                              </>
                            );
                          })}
                        </DropdownMenu>
                      </Dropdown>
                      {decode?.clientId==="98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" && 
                        <Box sx={{display:'flex', flexDirection:'row', alignItems:'center',ml:3, pr:2}}>
                          <Typography className='item-label'>Trade Advance</Typography> 
                            <MuiSwitch checked={taChange} name="tradeAdvance" onChange={handleTASwitchChange} />
                            <Typography className='item-label'>{taChange? "Yes": "No"}</Typography> 
                          </Box>
                      } 
                    </div>
                    {/* First Part */}
                  {decode?.clientId==="98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" ?
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems:'center', flexWrap:'wrap', paddingTop: '24px', paddingRight: '1em'}}>
                        <div className='each-item'>
                          <p className='item-label'>Tenure</p>
                          <Input
                            type="number"
                            id="tenure"
                            placeholder="tenure"
                            disabled
                            value={(form?.tenure === 0 || form.tenure == null) ? ApplicantId?.ApplicantId?.tenure : form?.tenure}
                            className='item-input'
                          />
                        </div>
                        <div className='each-item'>
                          <p  className='item-label'>Loan Amount</p>
                          <Input
                            type="number"
                            id="loanAmount"
                            placeholder="loan amount"
                            onChange={(e) => setLoanAmount(e.target.value)}
                            className='item-input'
                          />
                      </div>
                      <div  className='each-item'>
                        <p  className='item-label'>EMI</p>
                        <Input
                          type="number"
                          id="defaultEMI"
                          placeholder="emi"
                          disabled
                            className='item-input'
                          onChange={(e)=>setEMI(e.target.value)}
                        />      
                      </div>
                      <div  className='each-item'>
                        <p  className='item-label'>First Date of EMI</p>
                        <Datetime
                         closeOnSelect="false"
                          id="fistDateOfEmi"
                          dateFormat="YYYY/MM/DD"
                          timeFormat={false}
                          isValidDate={(current) => current.isAfter(moment().add(15, 'days'))}
                          onChange={(event) => {
                            if(typeof event==="string"){
                              setEmiDate(null)
                            }else if(event && event.format){
                              setEmiDate(event.format('YYYY/MM/DD'))
                            }

                          }}
                          locale="en-gb"
                          inputProps={{ placeholder: 'select date', style:{height: '30px', fontSize:'14px'}}}
                          className='item-input'
                        />
                      </div>
                      <div  className='each-item'>
                        <p  className='item-label'>Day of EMI</p>
                        <Input
                          type="number"
                          id="dayOfEmi"
                          onWheel={(e) => {
                          e.target.blur()
                          e.stopPropagation()
                          setTimeout(() => {
                            e.target.focus()
                          }, 0)}}
                          placeholder="enter day(1-30)"
                          onChange={(e) => setEmiDay(e.target.value)}
                            className='item-input'
                        />  
                      </div>
                      <div   className='each-item'>
                        <p  className='item-label'>Disbursement Date - (optional)</p>
                        <Datetime
                          id="disbursementDate"
                          closeOnSelect="false"
                          dateFormat="YYYY/MM/DD"
                          timeFormat={false}
                          onChange={(event) => {
                            if(typeof event==="string"){
                              setDisbursementDate(null)
                            }else if(event && event.format){
                              setDisbursementDate(event.format('YYYY/MM/DD'))
                            }
                          
                          }}
                          locale="en-gb"
                          inputProps={{ placeholder: 'select date',style:{height: '30px', fontSize:'14px'} }}
                          className='item-input'
                        />
                      </div>
                      <div   className='each-item'>
                        <p  className='item-label'>Processing Fee</p>
                        <Input
                          type="number"
                          id="pf"
                          disabled
                          placeholder="processing fee"
                          className='item-input'
                          value={calculatePfValue("actualPf")}
                        />  
                      </div>
                      <div className='each-item'>
                        <p className='item-label'>Discount</p>
                       <Input
                          type="number"
                          id="discount"
                          onWheel={(e) => {
                          e.target.blur()
                          e.stopPropagation()
                          setTimeout(() => {
                            e.target.focus()
                          }, 0)}}
                          placeholder="enter discount"
                          onChange={(e) => setDiscountOnPf(e.target.value)}
                          value={discountOnPf}
                          className='item-input'
                        />  
                      </div>
                      <div className='each-item'>
                        <p className='item-label'>PF After Discount</p>
                       <Input
                          type="number"
                          id="pfAfterDisCount"
                          disabled
                          placeholder="enter discount"
                          className='item-input'
                          value={calculatePfValue('pfAfterDisCount')}
                        />  
                      </div>
                      <div className='each-item'>
                        <p className='item-label'>Total PF Value + GST</p>
                       <Input
                          type="number"
                          id="pfPlusGst"
                          disabled
                          placeholder="enter discount"
                          value={calculatePfValue("pfAfterGst")}
                          className='item-input'
                        />  
                      </div>
                      <div   className='each-item'>
                        <p  className='item-label'>Document Charges</p>
                        <Input
                          type="number"
                          id="documentCharges"
                          disabled
                          placeholder="document charges"
                          className='item-input'
                          value={calculatePfValue("actualPf")}
                        />  
                      </div>
                      <div className='each-item'>
                        <p className='item-label'>Discount</p>
                       <Input
                          type="number"
                          id="discountOnDocumentCharges"
                          onWheel={(e) => {
                          e.target.blur()
                          e.stopPropagation()
                          setTimeout(() => {
                            e.target.focus()
                          }, 0)}}
                          placeholder="enter discount"
                          onChange={(e) => setDiscountOnDc(e.target.value)}
                          value={discountOnDc}
                          className='item-input'
                        />  
                      </div>
                      <div className='each-item'>
                        <p className='item-label'>Document Charges After Discount</p>
                       <Input
                          type="number"
                          id="documentChargesAfterDisCount"
                          disabled
                          placeholder="enter discount"
                          className='item-input'
                          value={calculatePfValue('dcAfterDisCount')}
                        />  
                      </div>
                      <div className='each-item'>
                        <p className='item-label'>Total Document Charges Value + GST</p>
                       <Input
                          type="number"
                          id="dcPlusGst"
                          disabled
                          placeholder="enter discount"
                          value={calculatePfValue("dcAfterGst")}
                          className='item-input'
                        />  
                      </div>
                      <div className='each-item'>
                        <p className='item-label'>Emis Deducted</p>
                        <Input
                          type="number"
                          id="emisDeducted"
                          placeholder="eg. 1  should less than tenure"
                          onChange={handleDeductEmis}
                          className='item-input'
                        />
                      </div>
                    </div>
                    : 
                     <div style={{paddingTop: '24px', paddingRight: '1em'}}>
                      {fundSourceName === "AVN" ? 
                      <>
                      <div>
                       <div className='each-item'>
                          <p className='item-label'>Course</p>
                          <Input
                            type="text"
                            id="course"
                            placeholder="course"
                            className='input-field'
                            value={courseInputValue} 
                            onChange={handleInputChange}
                            autoComplete="off" 
                          />
                        </div>
                         {instituteList && instituteList.length > 0 && (
                            <div  style={{
                              position: 'relative', 
                              zIndex: 10, 
                              maxHeight: '200px',
                              maxWidth:'200px',
                              overflowY: 'auto',
                              backgroundColor: 'white', 
                              border: '1px solid #ccc',
                              borderRadius: '0.5em',
                              marginTop: '0.5em',
                              boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
                            }}>
                              {instituteList.map((item) => (
                                <div
                                  key={item.id}
                                  className="instituteName"
                                  style={{
                                    cursor: 'pointer',
                                    padding: '0.5em',
                                    borderBottom: '1px solid #eee'
                                  }}
                                  onClick={() => handleCourseSelect(item)} 
                                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'} 
                                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'} 
                                >
                                  <p style={{ fontWeight: '600', margin: 0 }}>{item.courseName}</p>
                                </div>
                              ))}
                            </div>
                          )}
                          </div>
                      </>:null}
                      
                          {fundSourceName === "AVN" ?
                          <>
                           <div style={{display:'flex'}}>
                          <div className='each-item'>
                          <p className='item-label'>Course Fees</p>
                          <Input
                            type="number"
                            id="coursefee"
                            placeholder="coursefee"
                            disabled
                            value={fee !== null ? fee : ''}
                            className='input-field'
                          />
                        </div>
                        <div className='each-item'>
                          <p className='item-label'>Discount Fee</p>
                          <Input
                            type="number"
                            id="discountfee"
                            placeholder="discountfee"
                            disabled
                            value={fee !== null ? calculatedDiscountFee : ''} 
                            className='input-field'
                          />
                        </div>
                        </div>
                          </>:null}
                            
                        <div className='each-item'>
                          <p  className='item-label'>Loan Amount</p>
                          <Input
                            type="number"
                            id="loanAmount"
                            placeholder="loan amount"
                            onChange={(e) => setLoanAmount(e.target.value)}
                            value={prodLoanAmount}
                            className='input-field'
                          />
                      </div>
                       <div className='each-item'>
                          <p className='item-label'>Tenure</p>
                          <Input
                            type="number"
                            id="tenure"
                            placeholder="tenure"
                            disabled
                            value={(form?.tenure === 0 || form.tenure == null) ? ApplicantId?.ApplicantId?.tenure : form?.tenure}
                            className='input-field'
                          />
                        </div>
                      <div  className='each-item'>
                        <p  className='item-label'>EMI</p>
                        <Input
                          type="number"
                          id="defaultEMI"
                          placeholder="emi"
                          disabled
                            className='input-field'
                          onChange={(e)=>setEMI(e.target.value)}
                        />      
                      </div>
                      <div  className='each-item'>
                        <p  className='item-label'>First Date of EMI</p>
                        <Datetime
                          closeOnSelect="false"
                          id="fistDateOfEmi"
                          dateFormat="YYYY/MM/DD"
                          timeFormat={false}
                          isValidDate={(current) => current.isAfter(moment().add(15, 'days'))}
                          onChange={(event) => {
                            if(typeof event==="string"){
                              setEmiDate(null)
                            }else if(event && event.format){
                              setEmiDate(event.format('YYYY/MM/DD'))
                            }

                          }}
                          locale="en-gb"
                          inputProps={{ placeholder: 'select date', style:{height: '30px', fontSize:'14px'}}}
                          className='input-field'
                        />
                      </div>
                      <div  className='each-item'>
                        <p  className='item-label'>Day of EMI</p>
                        <Input
                          type="number"
                          id="dayOfEmi"
                          onWheel={(e) => {
                          e.target.blur()
                          e.stopPropagation()
                          setTimeout(() => {
                            e.target.focus()
                          }, 0)}}
                          placeholder="enter day(1-30)"
                          onChange={(e) => setEmiDay(e.target.value)}
                            className='input-field'
                        />  
                      </div>
                      <div   className='each-item'>
                        <p  className='item-label'>Disbursement Date - (optional)</p>
                        <Datetime
                         closeOnSelect="false"
                          id="disbursementDate"
                          dateFormat="YYYY/MM/DD"
                          timeFormat={false}
                          onChange={(event) => {
                            if(typeof event==="string"){
                              setDisbursementDate(null)
                            }else if(event && event.format){
                              setDisbursementDate(event.format('YYYY/MM/DD'))
                            }
                          
                          }}
                          locale="en-gb"
                          inputProps={{ placeholder: 'select date',style:{height: '30px', fontSize:'14px'} }}
                          className='input-field'
                        />
                      </div>
                    </div>
                  }
                  </div>
                  <div
                    style={{
                      display: 'block',
                      paddingLeft: '3em',
                      borderLeft: '1px dashed #333',fontFamily:'Inter-Medium',fontSize:'14px'
                    }}
                  >
                    <p style={{ position: 'absolute',fontFamily:'Inter-Medium',fontSize:'14px' }}>Facility Type</p>
                    <div style={{ display: 'flex' }}>
                      <Input
                        type="button"
                        disabled={true}
                        id="inp1"
                        value="Discounted Interest"
                        placeholder="enter text"
                        onClick={() => {}}
                        style={{
                          height: '30px',
                          width: '150px',
                          marginRight: '1em',
                          marginTop: '3em',
                          borderRadius: '5px',fontFamily:'Inter-Medium',fontSize:'14px',
                          color: 'black',
                          fontWeight: 'bold',
                          backgroundColor: form.facilityType === 1 ? '#D32028' : '',
                        }}
                      />
                      <Input
                        type="button"
                        disabled={true}
                        id="inp1"
                        value="Standard Interest"
                        style={{
                          height: '30px',
                          width: '150px',
                          marginRight: '1em',
                          marginTop: '3em',
                          borderRadius: '5px',
                          fontWeight: 'bold',fontFamily:'Inter-Medium',fontSize:'14px',
                          color: 'black',
                          backgroundColor: form.facilityType === 2 ? '#D32028' : '',
                        }}
                      />
                      <Input
                        type="button"
                        disabled={true}
                        id="inp1"
                        value="Hybrid Interest"
                        onClick={() => {}}
                        style={{
                          height: '30px',
                          width: '150px',
                          marginTop: '3em',
                          marginRight: '1em',
                          borderRadius: '5px',fontFamily:'Inter-Medium',fontSize:'14px'
                        }}
                      />
                    </div>

                    <p style={{ position: 'absolute', marginTop: '10px',fontFamily:'Inter-Medium',fontSize:'14px' }}>Interest</p>
                    <div style={{ display: 'flex' }}>
                      {form.discountedInterestPercentage !== 0 && (
                        <Input
                          type="button"
                          value={
                            form.discountedInterestPercentage !== 0
                              ? (`${(form?.discountedInterestPercentage * 100)?.toFixed(2)} %`)
                              : 'N/A'
                          }
                          id="inp1"
                          placeholder="enter text"
                          onClick={() => {}}
                          style={{
                            height: '30px',
                            width: '165px',
                            marginTop: '3em',
                            borderRadius: '5px',
                            fontWeight: 'bold',fontFamily:'Inter-Medium',fontSize:'14px',
                            color: 'black',
                            backgroundColor: form.discountedInterestType === 1 ? '#D32028' : '',
                          }}
                        />
                      )}
                      <Input
                        type="button"
                        id="inp1"
                        disabled={true}
                        value={
                          form.standardInterestPercentage !== 0
                            ?  `${(form.standardInterestPercentage * 100)?.toFixed(2)} %`
                            : 'N/A'
                        }
                        placeholder="enter text"
                        style={{
                          height: '30px',
                          width: '165px',
                          marginTop: '3em',
                          borderRadius: '5px',fontFamily:'Inter-Medium',fontSize:'14px',
                          fontWeight: 'bold',
                          color: 'black',
                          backgroundColor: form.standardInterestType === 1 ? '#D32028' : '',
                        }}
                      />
                    </div>

                    <div style={{ display: 'flex' }}>
                      <p style={{ position: 'absolute', marginTop: '10px',fontFamily:'Inter-Medium',fontSize:'14px' }}>Process Fee</p>
                      <span style={{ position: 'relative', marginTop: '30px',fontFamily:'Inter-Medium',fontSize:'14px' }}>Flat</span>
                      <span style={{ position: 'relative', marginTop: '30px', marginLeft: '15px' ,fontFamily:'Inter-Medium',fontSize:'14px'}}>
                        Per(%)
                      </span>
                      <Input
                        type="radio"
                        id="inp1"
                        disabled
                        style={{
                          height: '20px',
                          width: '30px',
                          position: 'absolute',
                          marginTop: '4em',
                          borderRadius: '5px',fontFamily:'Inter-Medium',fontSize:'14px',
                        }}
                        checked={form.processingfeeType === 1 ? true : false}
                      />
                      <Input
                        type="radio"
                        id="inp1"
                        disabled
                        style={{
                          height: '20px',
                          width: '30px',
                          position: 'absolute',
                          marginTop: '4em',
                          marginLeft: '3em',fontFamily:'Inter-Medium',fontSize:'14px',
                          borderRadius: '5px',
                        }}
                        checked={form.processingfeeType === 2 ? true : false}
                      />
                      <p style={{ position: 'absolute', marginLeft: '9em', marginTop: '10px',fontFamily:'Inter-Medium',fontSize:'14px' }}>
                        Value
                      </p>
                      <Input
                        type="text"
                        id="inp1"
                        disabled
                        placeholder="value"
                        value={form.processingfeeType === 2 ?
                           `${(form?.processingfeeValue * 100)} %` :
                            form?.processingfeeValue
                          }

                        style={{
                          height: '30px',
                          marginLeft: '1em',fontFamily:'Inter-Medium',fontSize:'14px',
                          width: '100px',
                          marginTop: '3.5em',
                          borderRadius: '5px',
                          textAlign:'center'
                        }}
                      />

                      <p style={{ position: 'absolute', marginLeft: '16em', marginTop: '10px',fontFamily:'Inter-Medium',fontSize:'14px' }}>
                        GST applicable
                      </p>
                      <Input
                        type="checkbox"
                        id="inp1"
                        disabled
                        placeholder="enter text"
                        checked={form.processingfeeValueGST ? true : false}
                        style={{
                          height: '30px',
                          width: '50px',
                          textAlign: 'center',
                          marginLeft: '4em',fontFamily:'Inter-Medium',fontSize:'14px',
                          marginTop: '3.5em',
                          borderRadius: '5px',
                        }}
                      />
                      <p style={{ position: 'absolute', marginLeft: '27em', marginTop: '10px',fontFamily:'Inter-Medium',fontSize:'14px' }}>
                        Total Fee
                      </p>
                      <Input
                        type="text"
                        id="inp1"
                        disabled
                        placeholder="Total fee"
                        value={form.processingfeeType === 2 ? `${(form.processingfeValueIncludingGST * 100)} %`: form.processingfeValueIncludingGST}
                        style={{
                          textAlign: 'center',
                          height: '30px',
                          width: '115px',
                          marginLeft: '3em',
                          marginTop: '3.5em',
                          borderRadius: '5px',fontFamily:'Inter-Medium',fontSize:'14px'
                        }}
                      />
                    </div>

                    {decode?.clientId!=="98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" && <p style={{ position: 'absolute', marginTop: '25px',fontFamily:'Inter-Medium',fontSize:'14px'}}>FLDG(Yes/No)</p>}

                    {decode?.clientId!=="98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" && <div style={{ marginLeft: '8em', marginTop: '2em' ,fontFamily:'Inter-Medium',fontSize:'14px'}}>
                      {' '}
                      <Switch disabled onText="YES" offText="NO" value={form.fldgApplicable} />
                      {'  '}{' '}
                    </div>}
                     <div style={{ display: 'flex',gap:'16px', lineHeight:1.5, marginTop: '1em', padding: 0 }}>
                      <div>
                        <p style={{ fontFamily:'Inter-Medium',fontSize:'14px' }}>Advance EMIs</p>
                        <Input
                          type="text"
                          id="inp1"
                          disabled
                          title="number between 0-3"
                          placeholder="number between 0-3"
                          value={form.advanceEmis}
                          style={{
                            marginTop: '-14px',
                            height: '30px',
                            width: '100px',
                            borderRadius: '5px',fontFamily:'Inter-Medium',fontSize:'14px'
                          }}
                        />
                      </div>
                      {decode?.clientId!=="98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" && (
                        <div >
                          <p style={{  fontFamily:'Inter-Medium',fontSize:'14px' }}>
                            IRR
                          </p>
                          <Input
                            type="text"
                            id="inp1"
                            disabled
                            title="number between 0-3"
                            placeholder="number between 0-3"
                            value={form.irr}
                            style={{
                              marginTop: '-14px',
                              height: '30px',
                              width: '100px',
                              fontFamily:'Inter-Medium',
                              fontSize:'14px',
                              borderRadius: '5px',
                            }}
                          />
                        </div>
                      )}
                    
                      <div>
                        <p style={{ fontFamily:'Inter-Medium',fontSize:'14px',  }}>
                          Interest Type
                        </p>
                        <Input
                          type="text"
                          id="intrestType"
                          disabled
                          title="number between 0-3"
                          placeholder="number between 0-3"
                          value={form?.standardInterestType === 1 ? 'Reducing' : 'Flat'}
                          style={{
                             marginTop: '-14px',
                            height: '30px',
                            width: '100px',
                            fontFamily:'Inter-Medium',
                            fontSize:'14px',
                            borderRadius: '5px',
                          }}
                        />
                      </div>
                      <div>
                        <p style={{ fontFamily:'Inter-Medium',fontSize:'14px',  }}>
                          Interest Per
                        </p>
                        <Input
                          type="text"
                          id="interestPer"
                          disabled
                          title="number between 0-3"
                          placeholder="number between 0-3"
                          value={form?.tenureType === 2 ? "Annum" : 'Tenure'}
                          style={{
                            marginTop: '-14px',
                            height: '30px',
                            width: '100px',
                            fontFamily:'Inter-Medium',fontSize:'14px',
                            borderRadius: '5px',
                          }}
                        />
                      </div>
                      
                    </div>
                    {decode?.clientId!=="98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" && <p style={{  marginTop: '15px', fontWeight: '650',fontFamily:'Inter-Medium',fontSize:'14px' }}>
                      Disbursements
                    </p>}
                    {decode?.clientId!=="98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" &&<div style={{display: 'flex', flexDirection: 'column',justifyContent: 'center',}}>
                      <div style={{display: 'flex',justifyContent:'space-between', alignItems: 'center', lineHeight:2, width:'50%'}}>
                        <p style={{fontFamily:'Inter-Medium',fontSize:'14px'}}>Months:</p>
                        <ul
                          style={{
                            listStyle: 'none',
                            display: 'flex',
                            fontFamily:'Inter-Medium',fontSize:'14px',
                            gap: '30px'
                          }}
                        >
                          <li style={{ fontFamily:'Inter-Medium',fontSize:'14px'}}>{form.disbursementMonth1}</li>
                          <li style={{fontFamily:'Inter-Medium',fontSize:'14px' }}>{form.disbursementMonth2}</li>
                          <li style={{fontFamily:'Inter-Medium',fontSize:'14px' }}>{form.disbursementMonth3}</li>
                          <li style={{fontFamily:'Inter-Medium',fontSize:'14px'}}>{form.disbursementMonth4}</li>
                        </ul>
                      </div>
                      <div style={{display: 'flex',justifyContent:'space-between', alignItems: 'center', lineHeight:2, width:'50%' }}>
                        <p style={{fontFamily:'Inter-Medium',fontSize:'14px'}}>Percentage:</p>{' '}
                        <ul
                          style={{
                            listStyle: 'none',
                            display: 'flex',
                            gap:'30px'
                          }}
                        >
                          <li style={{fontFamily:'Inter-Medium',fontSize:'14px' }}>{form.disbursementMonth1Percentage}</li>
                          <li style={{ fontFamily:'Inter-Medium',fontSize:'14px' }}>{form.disbursementMonth2Percentage}</li>
                          <li style={{ fontFamily:'Inter-Medium',fontSize:'14px' }}>{form.disbursementMonth3Percentage}</li>
                          <li style={{fontFamily:'Inter-Medium',fontSize:'14px'}}>{form.disbursementMonth4Percentage}</li>
                        </ul>
                      </div>
                    </div>}
                  </div>
                </div>
              ) : (
                <></>
              )}

           
              {status === 'Add Co-Applicant'?!ocrReadDone? 
                 isLoading ? (
                                          <Box style={{ display: 'flex',alignItems:'center',justifyContent:'center',padding:'15%'}}>
                                          <CircularProgress />
                                        </Box>
                                        ): (    
              <><div style={{display:'flex',justifyContent: 'space-evenly',marginTop:'1em'}}>
          <div style={{display:'block'}}>
          <p style={{fontFamily:'Inter-Medium',fontSize:'14px'}}>Upload Aadhaar Front</p>
          <Input className="ocrUpload"   onChange={(e)=>previewOcrAadhaarFront(e)} type="file"/>
          <p style={{textAlign:'center',fontFamily:'Inter-Medium',fontSize:'14px'}}>Preview</p>

          <img style={{border:'none',maxWidth:'18em',height:'15em'}} id="ocrAadhaarFOutput" alt=""/>
          </div>
          <div style={{display:'block'}}>
          <p style={{fontFamily:'Inter-Medium',fontSize:'14px'}}>Upload Aadhaar Back</p>
          
          <Input className="ocrUpload"   onChange={(e)=>previewOcrAadhaarBack(e)}type="file"/>
          <p style={{textAlign:'center',fontFamily:'Inter-Medium',fontSize:'14px'}}>Preview</p>

          <img style={{marginLeft:'1em',border:"0",maxWidth: '18em',height:'15em'}} id="ocrAadhaarBOutput" alt=""/>

          </div>

          <div style={{display:'block'}}>
          <p style={{fontFamily:'Inter-Medium',fontSize:'14px'}}>Upload PAN</p>

          <Input className="ocrUpload"   onChange={(e)=>previewOcrPan(e)}type="file"/>
          <p style={{textAlign:'center',fontFamily:'Inter-Medium',fontSize:'14px'}}>Preview</p>
          <img style={{marginLeft:'1em',border:'none',maxWidth:'18em',height:'15em'}} id="ocrPanOutput" alt=""/>

          </div>

         
          </div>
            <div style={{alignSelf: 'center',marginLeft:'40%'}}>
            <button onClick={()=>readOcr()} style={{border:'none',borderRadius:'10px',width:'15em',backgroundColor:"#D22129",color:'white',fontFamily:'Inter-Medium',fontSize:'14px'}}  type="button">Trigger Coapplicant OCR</button>
            </div></>) :  <div style={{ display: 'flex' }}>
                  <div style={{ display: 'block' }}>
                   
                    <p style={{ marginTop: '1em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px' }}>Application Id</p>
                    <Input
                      type="text"
                      id="inp9"
                      disabled
                      value={ApplicantId.ApplicantId.applicationId}
                      style={{
                        height: '30px',
                        width: '350px',
                        fontFamily:'Inter-Medium',fontSize:'14px',
                        borderRadius: '5px',
                      }}
                    />
                    <Dropdown
                      style={{ marginTop: '1em' }}
                      isOpen={relationshipStatusDropdown}
                      toggle={() => handleRelationshipToggle()}
                    >
                      <DropdownToggle style={{backgroundColor:'#d32028',fontFamily:'Inter-Medium',fontSize:'14px'}} caret>
                        {relationshipStatus}
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem style={{fontFamily:'Inter-Medium',fontSize:'14px'}}   onClick={(e) => setRelationshipStatus(e.target.innerText)}>
                          Spouse
                        </DropdownItem>
                        <DropdownItem style={{fontFamily:'Inter-Medium',fontSize:'14px'}}  onClick={(e) => setRelationshipStatus(e.target.innerText)}>
                          Parent
                        </DropdownItem>
                        <DropdownItem style={{fontFamily:'Inter-Medium',fontSize:'14px'}}  onClick={(e) => setRelationshipStatus(e.target.innerText)}>
                          Guardian
                        </DropdownItem>
                        <DropdownItem style={{fontFamily:'Inter-Medium',fontSize:'14px'}}  onClick={(e) => setRelationshipStatus(e.target.innerText)}>
                          Friend
                        </DropdownItem>
                        <DropdownItem style={{fontFamily:'Inter-Medium',fontSize:'14px'}}  onClick={(e) => setRelationshipStatus(e.target.innerText)}>
                          Sibling
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                    <div style={{display:'flex',justifyContent:'space-between'}}>
                    <p style={{ marginTop: '1em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px',width:'8em',lineHeight:'1.5em' }}> Co-Applicant Name</p>
                    <Input
                    defaultValue={ocrFormData?.fullNamePerPan}
                    valid={getStringContain(coAppFName)}
                    invalid={getStringContain(coAppFName)}
                      type="text"
                      id="coAppName"
                      placeholder="Co Applicant Name"
                      onChange={(e) => setCoAppFName(e.target.value)}
                      style={{
                        height: '30px',
                        width: '240px',fontFamily:'Inter-Medium',fontSize:'14px',
                        margin:'18px',
                        borderRadius: '5px',
                      }}
                    />
                </div>
                 <div style={{display:'flex',justifyContent:'space-between'}}>
                    <p style={{ marginTop: '1em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px',width:'8em',lineHeight:'1.5em'}}>Co-Applicant DOB</p>
                    <Input
                      defaultValue={ocrFormData?.dobPerAadhaar?ocrFormData?.dobPerAadhaar:ocrFormData?.dobPerPan}
                      type="date"
                      id="coAppDob"
                      placeholder="Date of Birth"
                    onChange={(e) => handleDOBChange(e.target.value)}
                      style={{
                        height: '30px',
                        width: '200px',fontFamily:'Inter-Medium',fontSize:'14px',
                        margin:'18px',
                        borderRadius: '5px',
                        borderColor: dobError ? 'red' : '',
                      }}
                    />
                 
                  </div>
                {dobError && (
                  <p style={{ color: 'red', fontSize: '12px', fontFamily: 'Inter-Medium', marginLeft: '49%', marginTop: '-30px' }}>
                    {dobError}
                  </p>
                )}
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <p style={{ marginTop: '1em', fontWeight: '700', fontFamily: 'Inter-Medium', fontSize: '14px', width: '8em', lineHeight: '1.5em' }}>Gender</p>
                  <select
                    value={coAppGender}
                    onChange={(e) => setCoAppGender(e.target.value)}
                    style={{
                      height: '30px',
                      width: '240px',
                      margin: '18px',
                      fontFamily: 'Inter-Medium',
                      fontSize: '14px',
                      borderRadius: '5px',
                      border: '1px solid #ced4da'
                    }}
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
                 <div style={{display:'flex',justifyContent:'space-between'}}>
                    <p style={{ marginTop: '1em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px',width:'8em',lineHeight:'1.5em'}}>Co-Applicant Phone Number</p>
                    <Input
                    valid={coAppNumber?coAppNumber.length===10?true:false:""}
                     
                    
                      type="number"
                      id="coAppNumber"
                      placeholder="Phone number of Co Applicant"
                      onChange={(e) => setCoAppNumber(e.target.value)}
                      style={{
                        height: '30px',
                        width: '240px',fontFamily:'Inter-Medium',fontSize:'14px',
                        margin:'18px',
                        borderRadius: '5px',
                      }}
                    />
                  </div>
                  {/* Work Details */}
                  <div>
                      <p style={{fontWeight: 'bold', fontSize: '14px', fontFamily:'Inter-Medium'}}>Employment</p>
                      <div style={{display:'flex', justifyContent:'center', marginTop: -10}}>
                        <RadioGroup
                          aria-labelledby="demo-controlled-radio-buttons-group"
                          name="controlled-radio-buttons-group"
                          row 
                          value={employment}
                          onChange={handleEmploymentChange}
                        >
                          <FormControlLabel value="EMPLOYED" control={<Radio size='small' />} label="Salaried" sx={{mr:5,  '& .MuiFormControlLabel-label': { fontFamily: 'Inter-Medium', fontWeight:'bold', fontSize: '14px' }}}/>
                          <FormControlLabel value="SELF_EMPLOYED" control={<Radio  size='small' />} label="Self Employed" sx={{mr:5, '& .MuiFormControlLabel-label': { fontFamily: 'Inter-Medium', fontWeight:'bold', fontSize: '14px' }}}/>
                          <FormControlLabel value="UNEMPLOYED" control={<Radio  size='small' />} label="Unemployed" sx={{mr:5, '& .MuiFormControlLabel-label': { fontFamily: 'Inter-Medium', fontWeight:'bold', fontSize: '14px' }}}/>
                        </RadioGroup>
                      </div>
                      {employment==='EMPLOYED' &&
                      <>
                      <div style={{display:'flex', justifyContent:'space-between'}}>
                       <p style={{ marginTop: '1.5em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px',width:'8em',lineHeight:'1.5em'}}>Employer Name</p>
                       <Input
                         id="employerName"
                         placeholder="Enter Employer Name"
                         onChange={(e) => setEmployerName(e.target.value)}
                         style={{
                           height: '30px',
                           width: '240px',fontFamily:'Inter-Medium',fontSize:'14px',
                           margin:'18px',
                           borderRadius: '5px',
                         }}
                       />
                       </div>
                       <div style={{display:'flex', justifyContent:'space-between'}}>
                       <p style={{ marginTop: '1.5em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px',width:'8em',lineHeight:'1.5em'}}>Salary</p>
                       <Input
                         id="salary"
                         type="number"
                         placeholder="Enter Salary Per Month"
                         onChange={(e) => setIncome(e.target.value)}
                         style={{
                           height: '30px',
                           width: '240px',fontFamily:'Inter-Medium',fontSize:'14px',
                           margin:'18px',
                           borderRadius: '5px',
                         }}
                       />
                       </div>

                       </>
                      }
                      {employment==='SELF_EMPLOYED' && 
                      <>
                      <div style={{display:'flex', justifyContent:'space-between'}}>
                       <p style={{ marginTop: '1em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px',width:'8em',lineHeight:'1.5em'}}>Type Of Business</p>
                       <Input
                         id="business"
                         placeholder="Enter Business Type"
                         onChange={(e) => setEmployerName(e.target.value)}
                         style={{
                           height: '30px',
                           width: '240px',fontFamily:'Inter-Medium',fontSize:'14px',
                           margin:'18px',
                           borderRadius: '5px',
                         }}
                       />
                       </div>
                       <div style={{display:'flex', justifyContent:'space-between'}}>
                       <p style={{ marginTop: '1em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px',width:'8em',lineHeight:'1.5em'}}>Income Per Month</p>
                       <Input
                         id="income"
                         type="number"
                         placeholder="Enter Income Per Month"
                         onChange={(e) => setIncome(e.target.value)}
                         style={{
                           height: '30px',
                           width: '240px',fontFamily:'Inter-Medium',fontSize:'14px',
                           margin:'18px',
                           borderRadius: '5px',
                         }}
                       />
                       </div>

                       </>
                      }
                  
                  </div>

                      <div style={{display:'block',marginTop:'2em'}}>
                      <p style={{ marginTop: '0.5em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px' }}>Upload Aadhaar (Front)</p>
                      <Input
                        type="file"
                        id="inp6"
                        disabled={ocrFormData?.aadhaarImage1?true:false}
                       
                        onChange={(e) => setAadhaarFrontUpload(e.target.files[0])}
                        style={{
                          height: '30px',
                          width: '300px',fontFamily:'Inter-Medium',fontSize:'14px',

                          borderRadius: '50px',
                        }}
                      />
                     { ocrFormData?.aadhaarImage1?<><img src={aadhaarImage1Url} alt="No File Uploaded" style={{borderRadius:'1em',backgroundColor:'#E8E8E8',margin:'15px',width:'20em',height:'10em',border:'1px dashed black',padding:'0.5em',}}/>
                     
                     </>
                     :
                     aadhaarFrontUpload?<><img src={aadhaarFrontPreview} alt="No File Uploaded" style={{borderRadius:'1em',backgroundColor:'#E8E8E8',margin:'15px',width:'20em',height:'10em',border:'1px dashed black',padding:'0.5em',}}/>
                     <Button id="aadhaarFrontUploadButton" className="infoFront" onClick={()=>handleAadhaarFrontFileUpload(aadhaarFrontUpload)}> Upload</Button></>: <p style={{color:'red',fontWeight:'550',marginTop:'-4em',fontFamily:'Inter-Medium',fontSize:'14px'}}>( Upload To See Preview )</p>}
                      </div>

                       <div style={{display:'block'}}>   
                      <p style={{ marginTop: '0.5em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px' }}>Upload Aadhaar (Back Side)</p>
                      <Input
                        type="file"
                        id="inp8"
                         disabled={ocrFormData?.aadhaarImage2?true:false}
                        onChange={(e) => setAadhaarBackUpload(e.target.files[0])}
                        style={{
                          height: '30px',
                          width: '300px',fontFamily:'Inter-Medium',fontSize:'14px',

                          borderRadius: '50px',
                        }}
                      />
                       {ocrFormData?.aadhaarImage2?<><img src={aadhaarImage2Url}alt="No File Uploaded" style={{borderRadius:'1em',backgroundColor:'#E8E8E8',margin:'15px',border:'1px dashed black',padding:'0.5em',width:'20em',height:'10em',}}/></>
                       :
                        aadhaarBackUpload ?<>
                        <img src={aadhaarBackPreview} alt="No File Uploaded" style={{borderRadius:'1em',backgroundColor:'#E8E8E8',margin:'15px',border:'1px dashed black',padding:'0.5em',width:'20em',height:'10em',}}/><Button id="aadhaarBackUploadButton" className="infoBack" onClick={()=>handleAadhaarBackFileUpload(aadhaarBackUpload)}> Upload</Button></>:<p style={{padding:'5px',fontFamily:'Inter-Medium',fontSize:'14px'}}>Upload to see Preview</p>}

                        </div>
                  </div>
                  <div style={{ display: 'block', borderLeft:'1px dashed black',marginLeft: '4em',paddingLeft:'4em' }}>
                   <div style={{display:'flex',justifyContent:'space-between',}}>
                    <p style={{ marginTop: '1em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px' }}>Co-Applicant Email</p>
                    <Input
                       valid={validateEmail(coAppEmail)}
                   
                      type="text"
                      id="coAppEmail"
                      placeholder="Enter Co Applicant Email"
                      onChange={(e) => setCoAppEmail(e.target.value)}
                      style={{
                      height: '30px',
                        width: '240px',margin:'18px',fontFamily:'Inter-Medium',fontSize:'14px',

                        borderRadius: '5px',
                      }}
                    />
                    </div>
                     <div style={{display:'flex',justifyContent:'space-between',width:'15em'}}>
                    <p style={{ marginTop: '1em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px' }}>PAN</p>
                    <Input
                    valid={coAppPAN?coAppPAN.length===10:""}
                      defaultValue={ocrFormData?.panId}
                      type="text"
                      id="coAppPan"
                      placeholder="Enter PAN of Co Applicant"
                      onChange={(e) => setCoAppPAN(e.target.value)}
                      style={{
                        height: '30px',
                        width: '240px',margin:'18px',
                         textTransform: "uppercase",fontFamily:'Inter-Medium',fontSize:'14px',
                        borderRadius: '5px',
                      }}
                    />
                    </div>
                     <div style={{display:'flex',justifyContent:'space-between',width:'15em'}}>
                    <p style={{ marginTop: '1em', fontWeight: '700',fontFamily:'Inter-Medium',fontSize:'14px' }}>Aadhaar</p>
                    <Input
                      valid={coAppAadhaar?coAppAadhaar.length===12:""}
                      defaultValue={ocrFormData?.aadhaarId}
                      type="text"
                      id="inp5"
                      placeholder="Enter Aadhaar of Co Applicant"
                      onChange={(e) => setCoAppAadhaar(e.target.value)}
                      style={{
                      height: '30px',
                        width: '240px',margin:'18px',fontFamily:'Inter-Medium',fontSize:'14px',

                        borderRadius: '5px',
                      }}
                    />
                  </div>
                    <div
                      style={{ display: 'block', justifyContent: 'space-between', marginTop: '1em',fontFamily:'Inter-Medium',fontSize:'14px' }}
                    >
                    
                      
                       <div style={{display:'block'}}>
                      <p style={{ marginTop: '0.5em', fontWeight: '700' ,fontFamily:'Inter-Medium',fontSize:'14px'}}>Upload PAN </p>
                      <Input
                        type="file"
                        id="inp9"
                         disabled={ocrFormData?.panImage?true:false}
                        onChange={(e) => setPanUpload(e.target.files[0])}
                        style={{
                          height: '30px',
                          width: '300px',fontFamily:'Inter-Medium',fontSize:'14px',

                          borderRadius: '50px',
                        }}
                      />
                       {
                          
                        ocrFormData?.panImage?<><img src={panImageUrl} alt="No File Uploaded" style={{borderRadius:'1em',backgroundColor:'#E8E8E8',margin:'15px',width:'20em',height:'10em',border:'1px dashed black',padding:'0.5em',}}/></>
                        :
                        
                         panUpload?<><img src={pancardPreview} alt="No File Uploaded" style={{borderRadius:'1em',backgroundColor:'#E8E8E8',margin:'15px',width:'20em',height:'10em',border:'1px dashed black',padding:'0.5em',}}/><Button id="PanUploadButton" className="infoBack"  onClick={()=>handlePanFileUpload(panUpload)}> Upload</Button></>:<p style={{padding:'5px',fontFamily:'Inter-Medium',fontSize:'14px'}}>Upload file to see preview</p>
                       }
                       </div>

                        <div style={{display:'flex',justifyContent:'space-between'}}>
                        <p style={{fontWeight:'bold',fontFamily:'Inter-Medium',fontSize:'14px',width:'8em'}}>Co-Applicant Address</p>
                         <Input
                            defaultValue={ocrFormData?.address}
                            type="text"
                            id="inp23"
                            placeholder="Enter Co Applicant Address"
                            onChange={(e) => setCoAppAddress(e.target.value)}
                            style={{
                              height: '80px',
                              width: '350px',fontFamily:'Inter-Medium',fontSize:'14px',
                              borderRadius: '5px',
                              }}
                    />
                      </div>
                        <div style={{display:'flex',justifyContent: 'space-between',width:'22em',marginTop:'1em'}}>
                      <strong> City</strong>

                        <Input
                            defaultValue={ocrFormData?.city}
                            type="text"
                            id="inp23"
                            placeholder="City"
                            onChange={(e) => setCoAppCity(e.target.value)}
                            style={{
                              height: '40px',
                              width: '150px',fontFamily:'Inter-Medium',fontSize:'14px',
                              borderRadius: '5px',
                              }}
                    />
                  </div>
                    <div style={{display:'flex',justifyContent: 'space-between',width:'22em',marginTop:'1em'}}>
                      <strong> State</strong>
                      <select value={coAppState ||states.find( s => s.toLowerCase() === (ocrFormData?.state || "").toLowerCase()) || ""  }
                      onChange={(e) => setCoAppState(e.target.value)}
                        style={{
                          height: '40px',
                          width: '150px',fontFamily:'Inter-Medium',fontSize:'14px',
                          borderRadius: '5px',
                          }}>
                      {
                        states?.map((item, i)=>{
                          return(
                            <option name={item} value={item} key={i}>{item}</option>
                          )
                        })
                      }

                      </select>
                  </div>
                  
                  <div style={{display:'flex',justifyContent: 'space-between',width:'22em',marginTop:'1em'}}>
                   <strong> ZIP</strong>
                         <Input
                            defaultValue={ocrFormData?.pincode}
                            type="text"
                            id="coAppZip"
                            placeholder="Pincode"
                            onChange={(e) => setCoAppPincode(e.target.value)}
                            style={{
                              height: '40px',
                              width: '150px',fontFamily:'Inter-Medium',fontSize:'14px',
                              borderRadius: '5px',
                              }}
                    />
                  </div>
                    </div>
                        <div style={{display:'flex',backgroundColor:'#E0E0E0',borderRadius:'1em',marginTop:'1em',justifyContent:'space-around'}}>
                       <div style={{display:'flex', alignItems: 'center'}}>
                     <p  style={{fontWeight:'600',marginTop:'0.9em',fontFamily:'Inter-Medium',fontSize:'14px'}}> Run Emandate</p><input id="runEmandate" onChange={(e)=>handleRunEmandateBox(e.target.checked)} style={{borderRadius:'2em',marginLeft
                     :'1em',width: '1em', height: '1em'}} type="checkbox"/>
                     </div>
                     <div style={{display:'flex', alignItems: 'center'}}>
                     <p  style={{fontWeight:'600',marginTop:'0.9em',fontFamily:'Inter-Medium',fontSize:'14px'}}> Run Emandate For Both </p><input id="runBothEmandate"  onClick={(e)=>handleRunBothEmandateBox(e.target.checked)} style={{borderRadius:'2em',marginLeft
                     :'1em',width: '1em', height: '1em'}} type="checkbox"/>
                     </div>
                       </div>
                  </div>
               
              

       <Modal isOpen={mandateCheckOpen}>
        <ModalHeader>Confirmation Message</ModalHeader>
            <ModalBody>This Action will make <u>Co Applicant</u> as the  <strong>Main Applicant</strong>
        

      
        </ModalBody>
        <ModalFooter style={{backgroundColor:'#E0E0E0',color:'black',fontWeight:'600',paddingRight:'48%'}} onClick={()=>setMandateCheckOpen(!mandateCheckOpen)}>Close</ModalFooter>
      </Modal>
       <Modal isOpen={bothMandateCheckOpen}>
        <ModalHeader>Confirmation Message</ModalHeader>
        <ModalBody>Choose whom to be the <strong>Main Applicant</strong>
        

        <div style={{display:'flex',justifyContent: 'space-around',marginBottom:'1em'}}>
          <div style={{display:'block',}}>
          <p style={{fontWeight:'600',marginTop:'1em'}}>Applicant</p><input 
          id="applicantCheck"style={{width:'3em',height:'2em'}}name="mainApplicant" type="checkbox" onClick={(e)=>handleMainApplicantSelectApplicant()}/>
          </div>
          <div style={{display:'block'}}>
          <p style={{fontWeight:'600',marginTop:'1em'}}>Co Applicant</p><input id="coapplicantCheck"name="mainApplicant" style={{width:'3em',height:'2em'}} type="checkbox" onChange={(e)=>handleMainApplicantSelectCoApplicant()}/>
          </div>
        </div>
        </ModalBody>
        <ModalFooter style={{backgroundColor:'#E0E0E0',color:'black',fontWeight:'600',paddingRight:'48%'}} onClick={()=>setBothMandateCheckOpen(!bothMandateCheckOpen)}>Close</ModalFooter>
      </Modal> 
    </div>:null}
              {status === 'Rejected' ? (
                <>
                <p style={{  marginTop: '2em',fontFamily:"Inter-Medium",fontSize:'14px',lineHeight:'10px' }}>Remarks:</p>
                  <input
                    type="text"
                    id="description"
                    placeholder="Write Description Here"
                    style={{ height: '100px', width: '1000px',borderStyle:"solid",borderWidth:"1px", borderRadius: '5px',fontFamily:"Inter-Medium",fontSize:'14px' }}

                    onChange={(e) => handleDescriptionText(e.target.value)}
                  />
                </>
              ) : (
                <></>
              )}
              {status === 'Dropped' ? (
                <>
                <p style={{  marginTop: '2em',fontFamily:"Inter-Medium",fontSize:'14px',lineHeight:'10px' }}>Remarks:</p>
                  <input
                    type="text"
                    id="description"
                    placeholder="Write Description Here"
                    style={{ height: '100px', width: '1000px',borderStyle:"solid",borderWidth:"1px", borderRadius: '5px',fontFamily:"Inter-Medium",fontSize:'14px' }}
                    onChange={(e) => handleDescriptionText(e.target.value)}
                  />
                </>
              ) : (
                <></>
              )}
              {status === 'On Hold' ? (
                <>
                <p style={{  marginTop: '2em',fontFamily:"Inter-Medium",fontSize:'14px',lineHeight:'10px' }}>Remarks:</p>
                  <input
                    type="text"
                    id="description"
                    placeholder="Write Description Here"
                    style={{ height: '100px', width: '1000px',borderStyle:"solid",borderWidth:"1px", borderRadius: '5px',fontFamily:"Inter-Medium",fontSize:'14px' }}
                    onChange={(e) => handleDescriptionText(e.target.value)}
                  />
                </>
              ) : (
                <></>
              )}
          <OtpConsent openOtpConsent={openOtpConsent} submitApplicationToInReview={submitApplicationToInReview} handleConsent={handleConsent} mobile={coAppNumber}/>       
        </ModalBody>
        {status !=="Select Status" && (
        <ModalFooter style={{display:"flex",justifyContent:"center",backgroundColor:"#E9E9E9"}}>
          
          <Button style={{backgroundColor:"#D32028",color:"white",fontFamily:"Inter-Medium",fontSize:"13px",border:"solid",borderRadius:"5px",borderWidth:"1px",height:"30px"}} disabled={formLoader} onClick={() => handleStatusChange()}>
            Save and Submit  
          </Button>
          {/* {fundSourceName === "FIB" ? (<>
            <Button style={{backgroundColor:"#D32028",color:"white",fontFamily:"Inter-Medium",fontSize:"13px",border:"solid",borderRadius:"5px",borderWidth:"1px",height:"30px",marginLeft:'2em'}} disabled={formLoader} onClick={() => handleReingestToFib()}>
            Re-Ingest  
          </Button>
          </>):null} */}
          {alertMessage?<p style={{ backgroundColor:'#fff0ce',padding:'5px',borderRadius:'10px',color:'red',fontWeight:'bold'}}>{alertMessage}</p>:""}
        </ModalFooter>
        )}
      </Modal>

       <Modal isOpen={mandateCheckOpen}>
        <ModalHeader>Confirmation Message</ModalHeader>
            <ModalBody>This Action will make <u>Co Applicant</u> as the  <strong>Main Applicant</strong>
        

      
        </ModalBody>
        <ModalFooter style={{backgroundColor:'#E0E0E0',color:'black',fontWeight:'600',paddingRight:'48%'}} onClick={()=>setMandateCheckOpen(!mandateCheckOpen)}>Close</ModalFooter>
      </Modal>
       <Modal isOpen={bothMandateCheckOpen}>
        <ModalHeader>Confirmation Message</ModalHeader>
        <ModalBody>Choose whom to be the <strong>Main Applicant</strong>
        

        <div style={{display:'flex',justifyContent: 'space-around',marginBottom:'1em'}}>
          <div style={{display:'block',}}>
          <p style={{fontWeight:'600',marginTop:'1em'}}>Applicant</p><input 
          id="applicantCheck"style={{width:'3em',height:'2em'}}name="mainApplicant" type="checkbox" onClick={(e)=>handleMainApplicantSelectApplicant()}/>
          </div>
          <div style={{display:'block'}}>
          <p style={{fontWeight:'600',marginTop:'1em'}}>Co Applicant</p><input id="coapplicantCheck"name="mainApplicant" style={{width:'3em',height:'2em'}} type="checkbox" onChange={(e)=>handleMainApplicantSelectCoApplicant()}/>
          </div>
        </div>
        </ModalBody>
        <ModalFooter style={{backgroundColor:'#E0E0E0',color:'black',fontWeight:'600',paddingRight:'48%'}} onClick={()=>setBothMandateCheckOpen(!bothMandateCheckOpen)}>Close</ModalFooter>
      </Modal> 
    </div>
  );
}





